
import { get } from 'vuex-pathify'

export default {
  inheritAttrs: false,
  props: {
    icon: {
      type: String,
      default: 'cart'
    },
    badge: {
      type: Boolean,
      default: true
    }
  },
  vessel: {
    quantity: {
      backgroundColor: 'success',
      textColor: 'white',
      borderRadius: 'full',
      textSize: 'xs',
      paddingY: '2xs',
      paddingX: 'xs',
      position: 'absolute',
      leading: 'xs',
      pinTop: true,
      pinRight: true,
      pointerEvents: 'none',
      negativeMarginRight: '2xs',
      negativeMarginTop: '2xs'
    }
  },
  computed: {
    quantity: get('shoppingCart/totalItems'),
    showBadge() {
      return this.badge && this.quantity > 0
    }
  }
}
